import { combineReducers } from 'redux';
import ReducerOptions from './reducer-options';

const allReducers = combineReducers({
  options: ReducerOptions
});

export default allReducers;
